import type { IProject } from '@/types';

const getProjectFromJson = async (
  jsonUrl: string
): Promise<IProject | null> => {
  try {
    const projectResponse = await fetch(jsonUrl);
    if (!projectResponse.ok) return null;
    return (await projectResponse.json()) as IProject;
  } catch {
    return null;
  }
};

export default getProjectFromJson;
